import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-base-button',
  templateUrl: './base-button.component.html',
  styleUrls: ['./base-button.component.scss'],
})
export class BaseButtonComponent implements OnInit {
  @Input() label!: string;
  @Input() btnImage!: string;
  @Input() colorClasses!: string;
  @Input() size!: string;
  @Input() type?: string;
  @Input() disabled?: boolean;
  @Output() onClick = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  doClick() {
    if (!this.disabled) this.onClick.emit();
  }
}
